import { FIXTURE_STATE_CONFIG } from "@/utils/constants.js";
import { REWARD_TYPE } from "@/hooks/contest/contestStatus.js";
import { RhinoshieldStepWelcome } from "@/components/brandDemo/RhinoshieldStepWelcome.jsx";

/**
 * Config de la démo de prospection RHINOSHIELD.
 * Route : /rhinoshield
 */
export const RHINOSHIELD_CONFIG = {

    /* ─── IDENTITÉ DE MARQUE ─────────────────────────────────────── */
    brand: {
        name: "RHINOSHIELD",
        logoUrl: "https://cdn.shopify.com/s/files/1/0274/8717/files/rhinoshield-logo.svg",
        websiteUrl: "https://rhinoshield.fr",

        fonts: {
            heading: "Poppins",
            body: "Poppins",
            googleFontsUrl: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800;900&display=swap",
        },

        colors: {
            pageBg:        "#FFFFFF", // fond blanc épuré — identité RHINOSHIELD
            accent:        "#FFEF00", // jaune signature RHINOSHIELD
            accentText:    "#1D1D1E", // texte noir sur fond jaune
            highlight:     "#1D1D1E", // badges noirs
            highlightText: "#FFFFFF", // texte blanc sur badges noirs
            goalFlash:     "#FFEF00", // flash "BUT !" en jaune
            error:         "#FF4444",
        },
    },

    /* ─── ÉCRAN D'ACCUEIL ────────────────────────────────────────── */
    welcome: {
        partner:        null,
        rewardImageUrl: "https://media.ldlc.com/r1600/ld/products/00/06/27/51/LD0006275196.jpg",
        rewardTitle:    "iPhone 17",
        rewardSubtitle: "Valeur 799€",
    },

    /* ─── ÉTAPE SEGMENTATION ─────────────────────────────────────── */
    segmentation: {
        products: [
            {
                id: "solidsuit",
                label: "SolidSuit",
                desc: "Protection extrême",
                imgUrl: "https://cdn.shopify.com/s/files/1/0274/8717/files/product-card_solidx_iphone-17.png",
            },
            {
                id: "clearx",
                label: "ClearX",
                desc: "Transparente & légère",
                imgUrl: "https://cdn.shopify.com/s/files/1/0274/8717/files/product-card_clear_iphone-17.png",
            },
            {
                id: "airx",
                label: "AirX",
                desc: "Coussin d'air breveté",
                imgUrl: "https://cdn.shopify.com/s/files/1/0274/8717/files/product-card_airx_iphone-16.png",
            },
            {
                id: "impact",
                label: "Impact Shield",
                desc: "Film de protection",
                imgUrl: "https://cdn.shopify.com/s/files/1/0274/8717/files/product-card_impact-protector_0901.png",
            },
        ],
    },

    /* ─── ÉCRAN DE RÉSULTAT ──────────────────────────────────────── */
    result: {
        confettiColors: ["#FFEF00", "#1D1D1E", "#FFFFFF"],
        socials: [
            { platform: "instagram", url: "https://www.instagram.com/rhinoshield_fr" },
            { platform: "tiktok",    url: "https://www.tiktok.com/@rhinoshield_fr" },
            { platform: "facebook",  url: "https://www.facebook.com/rhinoshield.fr" },
            { platform: "twitter",   url: "https://twitter.com/RhinoShieldFR" },
        ],
    },

    /* ─── DONNÉES DE LA DÉMO ─────────────────────────────────────── */
    demoContest: {
        fixture: {
            type: "FOOTBALL",
            id: 7,
            startingAt: "2025-12-13 15:00:00",
            label: "Finale",
            state: FIXTURE_STATE_CONFIG.SECOND_HALF,
            minutes: 78,
            extraMinutes: null,
            league: { name: "DEMO CUP", logoUrl: null },
        },
        coverUrl: "https://cdn.shopify.com/s/files/1/0274/8717/files/homepage_banner_iphone-17_sm.jpg",
        place: {
            id: 2,
            name: "The Phone Club",
            address: "12 Rue du Commerce, 75015 Paris, France",
            googlePlaceId: null,
        },
        defaultRewardLabel: "Une coque offerte",
        defaultWinnerReward: { title: "1 Coque SolidSuit",       type: REWARD_TYPE.PHYSICAL, code: "WIN-RHINO" },
        defaultLoserReward:  { title: "Impact Shield offert",    type: REWARD_TYPE.PHYSICAL, code: "LOSE-RHINO" },
        rewardsByLang: {
            fr: { rewardLabel: "Une SolidSuit à gagner",         winnerReward: { title: "1 Coque SolidSuit iPhone 17",  type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "-15% sur tout le site",           type: REWARD_TYPE.PHYSICAL, promoCode: "RHINO-15" } },
            en: { rewardLabel: "Win a SolidSuit case",           winnerReward: { title: "1 SolidSuit iPhone 17 Case",   type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "-15% sitewide",                   type: REWARD_TYPE.PHYSICAL, promoCode: "RHINO-15" } },
            es: { rewardLabel: "Gana una funda SolidSuit",       winnerReward: { title: "1 Funda SolidSuit iPhone 17",  type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "-15% en toda la web",             type: REWARD_TYPE.PHYSICAL, promoCode: "RHINO-15" } },
            it: { rewardLabel: "Vinci una SolidSuit",            winnerReward: { title: "1 Cover SolidSuit iPhone 17",  type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "-15% su tutto il sito",           type: REWARD_TYPE.PHYSICAL, promoCode: "RHINO-15" } },
            pt: { rewardLabel: "Ganhe uma SolidSuit",            winnerReward: { title: "1 Capa SolidSuit iPhone 17",   type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "-15% em todo o site",             type: REWARD_TYPE.PHYSICAL, promoCode: "RHINO-15" } },
            de: { rewardLabel: "Gewinne eine SolidSuit-Hülle",   winnerReward: { title: "1 SolidSuit iPhone 17 Hülle",  type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "-15% auf der gesamten Website",   type: REWARD_TYPE.PHYSICAL, promoCode: "RHINO-15" } },
        },
    },

    /* ─── SURCHARGES DE COMPOSANTS ───────────────────────────────── */
    components: {
        StepWelcome: RhinoshieldStepWelcome,
    },
};
